import { baseConfig } from '../../config/algolia';
import { serviceHelper } from '../../config/service-helper';
import { AddressValidationClient } from '@jbhi-fi/apis/src/addressValidation';

export function getAddressValidationClient(countryCode?: 'NZ' | 'AU') {
  return new AddressValidationClient({
    url: serviceHelper.addressValidationURL ?? '',
    accessToken: serviceHelper.addressValidationApiKey ?? '',
    isoCountryCode: countryCode ?? (window.Jbhifi?.storeLocation || 'AU'),
    addressValidationApiSource: 'qas',
    algoliaAppId: baseConfig.app_id ?? '',
    algoliaSearchApiKey: baseConfig.search_api_key ?? '',
  });
}
